<template>
  <v-app :class="getUI()">
    <v-toolbar
      app
      class="elevation-0 top-header"
      height="64"
      v-if="isLoggedIn || $route.name == 'B0101' || $route.name === 'resetPwd'"
    >
      <v-toolbar-title class="headline">
        <div @click="backToHome()" class="logo">
          <!-- <router-link :to="{ name: 'B0102' }"> -->
          <img :src="require('@/assets/logo.png')" />
          <!-- </router-link> -->
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down" v-if="isLoggedIn">
        <v-btn v-if="hasTdoc()" flat to="/t-doc">
          <span class="mr-2">TDocSS</span>
        </v-btn>
        <v-menu
          class="manu"
          left
          offset-y
          v-if="this.$store.state.stages.length > 0"
        >
          <v-btn v-if="!onlyHasTdoc()" flat slot="activator">{{
            $t(`app.manu`)
          }}</v-btn>
          <v-list>
            <v-list-tile
              :key="index"
              :to="'/' + item.to"
              class="item"
              v-for="(item, index) in this.$store.state.stages"
            >
              <div class="seq">
                <span>{{ index + 1 }}</span>
              </div>
              <div class="name">{{ $t(`menus.${item.to}`) }}</div>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu left offset-y v-if="masters.length > 0">
          <v-btn flat slot="activator">{{ $t(`app.master`) }}</v-btn>
          <v-card style="background-color: #fff !important" width="600px">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex :key="index" v-for="(item, index) in masters" xs6>
                  <v-btn :to="item.path" flat
                    >{{ item.name }} - {{ $t(`menus.${item.name}`) }}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-menu>
        <v-btn flat to="/B0200" v-permit.SHARP_QS_SEARCH>
          <span class="mr-2">見積</span>
        </v-btn>
        <v-btn flat to="/B1500" v-permit.SHARP_PO_SEARCH>
          <span class="mr-2">{{ $t("B1500.title") }}</span>
        </v-btn>
        <v-menu
          left
          offset-y
          v-permit.SHARP_PCS_SEARCH.SHARP_ICS_SEARCH.SHARP_PSCS_SEARCH
        >
          <v-btn flat slot="activator">
            変更・取消
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile flat to="/B1800" v-permit.SHARP_PCS_SEARCH>
              <span class="mr-2">P/O 変更・取消</span>
            </v-list-tile>
            <v-list-tile flat to="/B20000" v-permit.SHARP_ICS_SEARCH>
              <span class="mr-2">INV 変更・取消</span>
            </v-list-tile>
            <v-list-tile flat to="/B1900" v-permit.SHARP_PSCS_SEARCH>
              <span class="mr-2">S/A 変更・取消</span>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-btn flat to="/B1300" v-permit.SHARP_SIP_SEARCH.SHARP_SIB_SEARCH>
          <span class="mr-2">{{ $t("B1300.title") }}</span>
        </v-btn>
        <v-btn flat to="/bulletin" v-permit.SHARP_MB_SEARCH>
          <span class="mr-2">お知らせ</span>
        </v-btn>
        <v-btn
          flat
          to="/B1700"
          v-permit.SHARP_DR_SUM_EIAJ.SHARP_PSCS_FREIGHT.SHARP_DR_SUM_SUPPLIER.SHARP_DR_SUM_LOCAL_FEE
        >
          <span class="mr-2">財務実績帳票</span>
        </v-btn>
        <v-btn v-if="!onlyHasTdoc()" flat to="/B0102">
          <span class="mr-2">{{ $t(`app.home`) }}</span>
        </v-btn>
        <v-menu left offset-y>
          <v-btn flat slot="activator">
            {{ user.fullName }}
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile flat to="/b2b/sa/monitor" v-if="isAdmin()">
              <span class="mr-2">SA Monitor</span>
            </v-list-tile>
            <v-list-tile flat to="/b2b/sa/tracking" v-if="isAdmin()">
              <span class="mr-2">SA Tracking</span>
            </v-list-tile>
            <v-list-tile flat to="/b2b/po/monitor" v-if="isAdmin()">
              <span class="mr-2">PO Monitor</span>
            </v-list-tile>

            <v-list-tile flat to="/mail/monitor" v-if="isAdmin()">
              <span class="mr-2">Mail Monitor</span>
            </v-list-tile>
            <v-list-tile flat to="/b2b/operation/monitor" v-if="isAdmin()">
              <span class="mr-2">Operation Monitor</span>
            </v-list-tile>
            <v-list-tile flat to="/M2500" v-if="isAdmin()">
              <span class="mr-2">冻结配置</span>
            </v-list-tile>
            <v-list-tile
              flat
              to="/b2b/adjust-container-history"
              v-if="isAdmin()"
            >
              <span class="mr-2">集装箱调整履历</span>
            </v-list-tile>
            <v-list-tile flat to="/foreign/write-off" v-if="isAdmin()">
              <span class="mr-2">外币 Monitor</span>
            </v-list-tile>
            <v-list-tile flat to="/jpy/write-off" v-if="isAdmin()">
              <span class="mr-2">日币 Monitor</span>
            </v-list-tile>
            <v-list-tile flat to="/monitor/shipment" v-if="isAdmin()">
              <span class="mr-2">SA接口监控</span>
            </v-list-tile>
            <v-list-tile flat to="/monitor/eiaj" v-if="isAdmin()">
              <span class="mr-2">EIAJ接口监控</span>
            </v-list-tile>
            <v-divider />

            <v-list-tile v-if="!onlyHasTdoc()" to="/videoIndex" flat>
              <span class="mr-2">manual</span>
            </v-list-tile>
            <v-list-tile @click="updatePsd" flat>
              <span class="mr-2">Update Password</span>
            </v-list-tile>
            <v-list-tile @click="logoff" flat>
              <span class="mr-2">Log Off</span>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu left offset-y>
          <v-btn flat slot="activator" style="min-width: 48px">
            <v-img :src="language.flag" width="26px" />
          </v-btn>
          <v-list>
            <v-list-tile
              :key="item.lang"
              @click="toggleLocale(item)"
              avatar
              v-for="item in languages"
            >
              <v-list-tile-avatar size="24px">
                <v-img :src="item.flag" />
              </v-list-tile-avatar>
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <div class="bg">
        <div class="left"></div>
        <div class="center"></div>
        <div class="right"></div>
      </div>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
      <message-alert ref="msgBox" />
      <full-message-alert ref="msgBoxs" />
      <confirm-dialog ref="confirmDlg" />
      <loading-message />
      <update-password ref="updatePassword" />
    </v-content>
    <v-footer>
      <div style="width: 100%; padding-right: 20px; text-align: right">
        V1.6.14
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import UpdatePassword from "@/components/UpdatePassword";

import { mapGetters } from "vuex";
export default {
  name: "App",
  components: {
    UpdatePassword,
  },
  data() {
    return {
      ui: "jusda-ui",
      languages: [
        {
          locale: "jp",
          name: "日本語",
          flag: require("@/assets/img/flags/jp.png"),
        },
        {
          locale: "en",
          name: "English",
          flag: require("@/assets/img/flags/us.png"),
        },
      ],
      language: null,
      businesses: this.$store.state.stages,
    };
  },
  created() {
    this.language = this.languages.find((l) => l.locale === this.$i18n.locale);
  },
  mounted() {
    this.$buriedPoint1();
    if (this.isSharp()) {
      this.ui = "sharp-ui";
    } else {
      this.ui = "jusda-ui";
    }
    console.log(this.$store.getters.user);
    this.dispMasterMenu = this.masters.length > 0;
    this.$bus.$on("message", (msg) => {
      this.$refs.msgBox.popup(msg.title, msg.content, msg.icon);
    });
    this.$bus.$on("fullMessage", (msg) => {
      this.$refs.msgBoxs.popup(msg.title, msg.content);
    });
    this.$bus.$on("confirm", (msg) => {
      this.$refs.confirmDlg.popup(msg);
    });
    this.$bus.$on("changeUI", (ui) => {
      this.ui = ui;
    });
  },
  methods: {
    getUI() {
      if (this.$route.name && this.$route.name.indexOf("Tdoc") > -1) {
        return "tdoc-ui";
      } else {
        return this.ui;
      }
    },
    isSharp() {
      var employee = JSON.parse(localStorage.getItem("currentEmployee"));
      if (!employee) {
        return false;
      }
      return employee.companyType === "SHARP";
    },
    backToHome() {
      var name;
      if (!this.onlyHasTdoc()) {
        name = "B0102";
      } else {
        name = "Tdoc";
      }
      this.$router.push({
        name: name,
      });
    },
    batchRemoveQueryCache(arr, prefix) {
      arr
        .map((i) => prefix + (i < 10 ? "0" + i : i) + "00")
        .forEach((i) => {
          localStorage.removeItem(i);
        });
    },
    homeClick() {
      let arr = [];
      for (let i = 1; i < 20; i++) {
        arr.push(i);
      }
      this.batchRemoveQueryCache(arr, "/B");
      this.batchRemoveQueryCache(arr, "/b");
    },
    logoff() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      localStorage.removeItem("currentEmployee");
      this.$store.dispatch("LOGOUT");
      this.$router.push("B0100");
    },
    toggleLocale(language) {
      this.language = language;
      this.$i18n.locale = this.language.locale;
      localStorage.setItem("locale", this.$i18n.locale);
    },
    updatePsd() {
      this.$refs.updatePassword.popup(false);
    },
    isAdmin() {
      var t = "TangoTE" === this.$store.getters.user.code;
      var f = "jory" === this.$store.getters.user.code;
      var alex = "UAC_101134" === this.$store.getters.user.userAccountId;
      var daniel = "UAC_100473" === this.$store.getters.user.userAccountId;
      var a = "AdminAlex" === this.$store.getters.user.code;
      var w = "AdminWang" === this.$store.getters.user.code;
      return (
        alex === true ||
        daniel === true ||
        t === true ||
        f === true ||
        a === true ||
        w === true
      );
    },
    onlyHasTdoc() {
      var userRoles = JSON.parse(localStorage.getItem("user")).roles;
      var tdocRoles = [
        "ROLE_SHRP_TDOC_VIEWER",
        "ROLE_TDOC_CARRIER",
        "ROLE_SJL_SHIPPER",
        "ROLE_WEB_VIEWER",
      ];
      for (var i = 0; i < userRoles.length; i++) {
        if (tdocRoles.indexOf(userRoles[i].roleCode) === -1) {
          return false;
        }
      }
      return true;
    },
    hasTdoc() {
      return (
        JSON.parse(localStorage.getItem("user")).functions.filter(
          (p) => p.code === "TDOC_SEARCH"
        ).length > 0
      );
    },
  },
  computed: {
    ...mapGetters(["isLoggedIn", "user"]),
    masters() {
      return (
        this.isLoggedIn &&
        this.$router.options.routes
          .filter((r) => r.path.match(/[Mm]\d{3}0$/))
          .filter((f) => f.meta && f.meta.permit && this.$permit(f.meta.permit))
          .sort((a, b) => a.name.localeCompare(b.name))
        //"1"
      );
    },
  },
};
</script>

<style scoped>
.headline {
  z-index: 9999;
}

.logo {
  cursor: pointer;
}

.logo img {
  width: 58px !important;
}

.footer {
  text-align: center;
}

/deep/ .v-menu__content {
  border-radius: 0px;
}

.item {
  height: 40px;
  line-height: 40px;
  width: 230px;
  border-bottom: 1px solid #eee;
}

.item:hover {
  background: black;
  color: white !important;
  border-bottom: 1px solid black;
}

.item /deep/ .primary--text {
  background: black !important;
  color: white !important;
}

.item /deep/ .v-list__tile {
  height: 40px;
  padding: 0px;
}

.name {
  font-size: 14px !important;
  font-family: "HanSansCN-Medium" !important;
}

.v-list {
  overflow: hidden;
  padding: 0px;
}

.seq {
  margin-right: 20px;
  text-align: center;
  font-size: 14px;
  font-family: Arial;
  font-weight: 100;
  color: #999 !important;
  width: 29px;
  height: 40px;
  background: transparent url("assets/img/home/right/d.png") no-repeat bottom
    left;
  background-size: 28px;
  z-index: 999;
}

.item:hover .seq {
  background: url("assets/img/home/right/e.png") no-repeat bottom left;
  background-size: 28px;
}

.item /deep/ .primary--text .seq {
  background: url("assets/img/home/right/e.png") no-repeat bottom left;
  background-size: 28px;
}

.item /deep/ .primary--text .seq span {
  color: white !important;
}

.item:hover /deep/ .seq span {
  color: white !important;
}

.seq span {
  width: 26px;
  display: inline-block;
  height: 26px;
  position: absolute;
  left: 0px;
  bottom: 6px;
}
</style>

<style>
@import url(./assets/style.css);

.sharp-ui1 .top-header {
  background-color: #f0f0f0 !important;
}

.jusda-ui .top-header {
  background-color: rgb(253, 193, 9) !important;
}

.top-header .bg {
  position: absolute;
  z-index: -9999;
  right: 0px;
  top: 0px;
}

.jusda-ui .top-header .bg .left {
  height: 64px;
  width: 94px;
  border-left: 94px solid transparent;
  border-right: 0px solid transparent;
  border-bottom: 64px solid #ffcd00;
  overflow: hidden;
  display: inline-block;
  position: absolute;
  right: 694px;
}

.jusda-ui .top-header .bg .center {
  width: 500px;
  height: 64px;
  background: #ffcd00;
  overflow: hidden;
  display: inline-block;
  position: absolute;
  right: 194px;
}

.jusda-ui .top-header .bg .right {
  height: 64px;
  width: 94px;
  border-top: 64px solid #ffcd00;
  border-left: 0px solid transparent;
  border-right: 94px solid transparent;
  border-bottom: 0px solid transparent;
  overflow: hidden;
  display: inline-block;
  position: absolute;
  right: 100px;
}

.sharp-ui .top-header .bg .left {
  height: 64px;
  width: 94px;
  border-left: 94px solid transparent;
  border-right: 0px solid transparent;
  border-bottom: 64px solid #e5e5e5;
  overflow: hidden;
  display: inline-block;
  position: absolute;
  right: 694px;
}

.sharp-ui .top-header .bg .center {
  width: 500px;
  height: 64px;
  background: #e5e5e5;
  overflow: hidden;
  display: inline-block;
  position: absolute;
  right: 194px;
}

.sharp-ui .top-header .bg .right {
  height: 64px;
  width: 94px;
  border-top: 64px solid #e5e5e5;
  border-left: 0px solid transparent;
  border-right: 94px solid transparent;
  border-bottom: 0px solid transparent;
  overflow: hidden;
  display: inline-block;
  position: absolute;
  right: 100px;
}

.sharp-ui .top-header .v-btn--active:before,
.sharp-ui .top-header .v-btn:hover:before,
.sharp-ui .top-header .v-btn:focus:before {
  background-color: transparent !important;
}

.sharp-ui .top-header .v-btn--active .v-btn__content {
  color: #d02d23 !important;
}

.sharp-ui .btn-search {
  background-color: #d02d23 !important;
  color: #fff !important;
}

.tdoc-ui .top-header {
  background-color: #1995eb !important;
}

.tdoc-ui .top-header .bg .left {
  height: 64px;
  width: 94px;
  border-left: 94px solid transparent;
  border-right: 0px solid transparent;
  border-bottom: 64px solid #1188ee;
  overflow: hidden;
  display: inline-block;
  position: absolute;
  right: 694px;
}

.tdoc-ui .top-header .bg .center {
  width: 500px;
  height: 64px;
  background: #1188ee;
  overflow: hidden;
  display: inline-block;
  position: absolute;
  right: 194px;
}

.tdoc-ui .top-header .bg .right {
  height: 64px;
  width: 94px;
  border-top: 64px solid #1188ee;
  border-left: 0px solid transparent;
  border-right: 94px solid transparent;
  border-bottom: 0px solid transparent;
  overflow: hidden;
  display: inline-block;
  position: absolute;
  right: 100px;
}
</style>
